import { Component, Renderer2 } from '@angular/core';
import { SIDEBAR_MENUS, USER_MENUS } from '../core/constants/dispatch-sidebar-menus';
import { AuthService as Auth0Service } from '@auth0/auth0-angular';
import { SessionService } from '@app/shared/helpers/index';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalStateService } from '@app/shared/states';
import { DatadogMonitoringService } from '@app/core/services';
import { Subject } from 'rxjs';
@Component({
  selector: 'layout-component',
  templateUrl: './page-layout.component.html',
  styleUrls: ['./page-layout.component.scss'],
})
export class LayoutComponent {
  destroy$: Subject<boolean> = new Subject<boolean>();
  logoImgExpand: any = '/assets/images/CES-logo-svg.svg';
  logoImgCollapse: any = '/assets/images/ces-logo-icon.svg';
  dispatcherSidebarMenu: any = SIDEBAR_MENUS;
  profileUserMenu: any = USER_MENUS;
  allSidebarMenus: any = [];
  appliedUserMenu: any = [];
  isExpand: boolean = false;
  userName: string = '';
  hamburgerClick: boolean = false;
  avatarName: string = '';
  selectedTheme: any = 'light-theme';
  switchThemeToggle: boolean = false;
  sidebarCollapseClass: string = '';
  userType: any = '';

  profileUrl: string;
  constructor(
    private route: ActivatedRoute,
    private render: Renderer2,
    private sessionService: SessionService,
    private auth0Service: Auth0Service,
    private router: Router,
    private globalState: GlobalStateService,
    private datadog: DatadogMonitoringService
  ) {
    this.setUserName();
    this.appliedUserMenu = this.profileUserMenu;
    this.allSidebarMenus = this.dispatcherSidebarMenu;
  }

  ngOnInit(): void {
    if (!this.globalState.getDatadogState()) {
      this.datadog.setDataDogRum();
    }
    this.setProfilePicture();
    this.checkPreviousTheme();
    this.auth0Service.user$.subscribe((data: any) => {
      if (data) {
        this.userName = data.nickname;
        this.avatarName = this.userName
          ?.split(' ')
          .map((n) => n[0])
          .join('');
      }
    });
  }

  /* Angular destroy fn */
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  /**
   * Add mfa menu
   */
  addMfaMenu() {
    let isMFAMenu: any = this.appliedUserMenu.find((item) => item.label == '2 Factor Auth');
    if (!isMFAMenu) {
      this.appliedUserMenu.splice(1, 0, {
        iconClass: 'icon-settings',
        label: '2 Factor Auth',
        link: 'admin/security',
      });
    }
  }
  /**
   * Set profile picture of active user.
   */
  setProfilePicture() {
    let avtar = this.route?.snapshot?.data.avatar;
    if (avtar) {
      avtar.then((d) => (this.profileUrl = d));
    }
  }

  /**
   * Check previous theme and apply it
   */
  checkPreviousTheme() {
    let theme = localStorage.getItem('theme') ?? this.render['engine'].bodyNode.className;
    if (theme) {
      this.selectedTheme = theme;
      this.switchThemeToggle = theme == 'dark-theme' ? true : false;
      this.setTheme(this.selectedTheme);
    }
  }

  /**
   * Apply theme
   */
  setTheme(theme) {
    this.render['engine'].bodyNode.className = theme;
    this.sessionService.setTheme(theme);
  }

  /**
   * Set username
   */
  setUserName() {
    this.userName = this.sessionService.getUserName();
    this.avatarName = this.userName
      ?.split(' ')
      .map((n) => n[0])
      .join('');
  }

  /**
   * Switch theme light/dark
   */
  public switchTheme() {
    this.switchThemeToggle = !this.switchThemeToggle;
    this.selectedTheme = this.switchThemeToggle ? 'dark-theme' : 'light-theme';
    this.setTheme(this.selectedTheme);
  }

  onSidebarCollapse($event) {
    this.isExpand = $event;
  }

  headerMenu(_$event) {
    this.isExpand = !this.isExpand;
  }

  /**
   * On menu click close sidebar for mobile devices
   */
  menuClick() {
    if (window.innerWidth <= 992) {
      this.isExpand = false;
    }
  }

  /**
   * Redirect to app list page
   */
  redirectApp() {
    this.router.navigate(['/account/apps']);
  }
}
